import { render, staticRenderFns } from "./FloatingAlert.vue?vue&type=template&id=6834e006&scoped=true"
import script from "./FloatingAlert.vue?vue&type=script&lang=js"
export * from "./FloatingAlert.vue?vue&type=script&lang=js"
import style0 from "./FloatingAlert.vue?vue&type=style&index=0&id=6834e006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834e006",
  null
  
)

export default component.exports